<template>
  <SAIDialogWrapper
    ref="dialog"
    @hide="onDialogHide"
    :display-hide-action="displayHideAction"
    :max-width="maxWidth"
    :persistent="persistent"
  >
    <div class="column items-center q-px-lg">
      <img
        v-if="imgUrl"
        :src="imgUrl"
        class="q-mb-md"
        :style="{ width: imgWidth }"
        alt="popup-img"
      />
      <p
        :class="[
          'q-pb-md text-weight-medium full-width text-grey-10',
          imgUrl ? 'text-title' : 'text-h4',
          { 'text-center': imgUrl }
        ]"
        v-if="header"
      >
        {{ header }}
      </p>
      <p :class="['q-mb-md text-body', { 'text-center': imgUrl }]" v-if="body">
        {{ body }}
      </p>
      <div
        :class="[
          'row full-width q-mb-md',
          imgUrl ? 'justify-center' : undefined
        ]"
      >
        <SAIBtn
          class="q-mr-sm"
          outline
          no-caps
          border-width="1px"
          v-if="cancelText"
          :label="cancelText"
          color="grey-6"
          @click.stop="hide"
        />
        <SAIBtn v-if="okText" :label="okText" no-caps @click.stop="ok" />
      </div>
    </div>
  </SAIDialogWrapper>
</template>

<script>
import SAIDialogWrapper from '../sai-dialog-wrapper';

export default {
  name: 'SAIDialog',
  props: {
    persistent: Boolean,
    displayHideAction: {
      type: Boolean,
      default: true
    },
    header: String,
    body: String,
    imgUrl: String,
    imgWidth: {
      type: String,
      default: '256px'
    },
    cancelText: String,
    okText: String,
    maxWidth: {
      type: String,
      default: '360px'
    }
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide() {
      this.$emit('hide');
    },
    ok() {
      this.$emit('ok');
      this.$refs.dialog.hide();
    }
  },
  components: {
    SAIBtn: () => import('../../atom/sai-btn'),
    SAIDialogWrapper
  }
};
</script>

<style lang="sass" scoped>
.q-dialog::v-deep
  .q-dialog__backdrop
    background: rgba(5,22,41,0.2)
</style>
